// extracted by mini-css-extract-plugin
module.exports =  {"overlay":"OBleV0g","content":"D0adXoI","mobile-full-screen":"QtKsFUv","mobileFullScreen":"QtKsFUv","container":"MyPJBkk"};